// utilities/StringReRenderer.js

export const splitAtSecondUnderscore = (string) => {
    const parts = string.split('_');
    return parts.slice(1).join('_');
};


export const splitAtFirstUnderscore = (string) => {
    const parts = string.split('_');
    // console.log(parts);
    return parts[0]??"";
};

export const getLetter = (name, int) => {
    const letter = name.charAt(int);
    // console.log(parts);
    return letter;
};

export const  stringToColor = (str) =>{
    let hash = 0;
    for (const char of str) {
        hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }
    return `#${[0, 8, 16].map(shift => {
        const value = (hash >> shift) & 0xFF;
        return value.toString(16).padStart(2, '0');
    }).join('')}`;
}
export const dateFormat = (dateStr = "" , format = "") => {
    const date = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, '0');

    const map = {
      DD: pad(date.getDate()),
      MM: pad(date.getMonth() + 1), 
      YY: String(date.getFullYear()).slice(-2),
      YYYY: date.getFullYear(),
      hh: pad(date.getHours()),
      mm: pad(date.getMinutes()),
      ss: pad(date.getSeconds()),
    };
  
    return format.replace(/DD|MM|YY|YYYY|hh|mm|ss/g, (matched) => map[matched]);

};

export const timeAgo = (date) => {
    const now = new Date();
    const past = new Date(date);
    const diffMs = now - past; 
  
    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30); 
  
    if (seconds < 60) return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    if (days < 30) return `${days} day${days !== 1 ? 's' : ''} ago`;
    return `${months} month${months !== 1 ? 's' : ''} ago`;
  }


// Optional helper function for title case
export const titleCase  = (s) => s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
.replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) 

// Default Export
/* export default {
    splitAtFirstUnderscore,
    titleCase,
    getLetter,
    stringToColor
}; */